module.exports = __webpack_public_path__ + "img/yilianGl11.6bc56364.png";